module.exports = {
    "Clear search": `Zoekactie wissen`
};


//# sourceMappingURL=nl-NL.main.js.map
